import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';;

import {  STORAGE_LAST_ROLE, OWNER, CUSTOMER } from 'src/environments/constant';

@Component({
  selector: 'app-app-entry',
  templateUrl: './app-entry.page.html',
  styleUrls: ['./app-entry.page.scss'],
})
export class AppEntryPage implements OnInit {

  constructor(private ngZone:NgZone, private router:Router) { 
    
  }

  ngOnInit() {
  }

  continueAsClient(){
    localStorage.setItem(STORAGE_LAST_ROLE,JSON.stringify(CUSTOMER))
    this.ngZone.run(() => this.router.navigate(['/']))
  }

  continueAsOwner(){
    localStorage.setItem(STORAGE_LAST_ROLE,JSON.stringify(OWNER))
    this.ngZone.run(() => this.router.navigate(['/register/login']))
  }
}
